module.exports = __webpack_public_path__ + "img/744.625c3af8.jpg";